export const headerRowStyle: React.CSSProperties = {
  background: "var(--color-p3, #1e293b)",
};

export function headerCellStyle(): React.CSSProperties {
  return {
    padding: "14px 24px",
    fontWeight: 500,
    fontSize: "0.875rem",
    color: "#fff",
    ...headerRowStyle,
    borderBottom: "none",
    textAlign: "left",
    whiteSpace: "nowrap",
  };
}

export const bodyCellStyle: React.CSSProperties = {
  padding: "14px 24px",
  verticalAlign: "middle",
  fontSize: "0.875rem",
  color: "#334155",
  borderTop: "1px solid #e5e7eb",
};

export const nameCellStyle: React.CSSProperties = {
  ...bodyCellStyle,
  fontWeight: 500,
  color: "#0f172a",
};

export const tableContainerStyle: React.CSSProperties = {
  border: "1px solid #e5e7eb",
  borderRadius: "0.5rem",
  overflowX: "auto",
  overflowY: "hidden",
  backgroundColor: "#fff",
};

export function zebraRowStyle(index: number): React.CSSProperties {
  return {
    backgroundColor: index % 2 === 0 ? "#fff" : "#f8fafc",
  };
}
